<template>
  <custom-callout
    class="mb-3"
    :has-toggle="false"
    :border-color="calloutBorderLeftColor"
  >
    <div class="row py-2">
      <div class="col-6 col-xl-1 column-text-result__container">
        <div class="color-secondary-6 font-13">Área:</div>
        <div class="color-black font-16">{{area}}</div>
      </div>

      <div class="col-6 col-xl-1 column-text-result__container">
        <div class="color-secondary-6 font-13">Tipo:</div>
        <div class="color-black font-16">{{type}}</div>
      </div>
      
      <div class="col-12 col-xl-4 column-text-result__container">
        <div class="color-secondary-6 font-13">Título:</div>
        <div class="color-black font-16">{{title}}</div>
      </div>
      
      <div class="col-12 col-xl-2 column-text-result__container">
        <div class="color-secondary-6 font-13">Modificado por:</div>
        <div class="color-black font-16">{{updatedBy ? updatedBy : '-'}}</div>
      </div>
      
      <div class="col-12 col-xl-2 column-text-result__container">
        <div class="color-secondary-6 font-13">Última modificación:</div>
        <div class="color-black font-16">{{updatedDate | dateTime }}</div>
      </div>

      <div class="col-12 col-xl-2 d-flex justify-content-center align-items-center">
        <div
          class="mr-3"
          @click="$emit('toggle', id)"
        >
          <custom-toggle
            :id="`switch-schedule-item-${id}`"
            sync
            v-model="active"
          />
        </div>
        <action-button
          :id="`edit-btn-${id}`"
          i="fas fa-edit"
          variant="outline-success"
          @click="$emit('edit', id)"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import { CustomToggle } from '@/components/common';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import { Colors } from '@/components/common';

export default {
  name: 'ScheduleItemResultRow',
  components: {
    CustomCallout,
    ActionButton,
    CustomToggle
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    area: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    updatedDate: {
      type: String,
      default: '',
    },
    updatedBy: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    calloutBorderLeftColor() {
      return this.active ? Colors.GREEN_LIGHT : Colors.GRAY;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

.column-text-result__container {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.status-badge__container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 43px;
  border-right: 1px solid #c3c3c3;
}

.status-badge {
  padding: 5px 20px;
  font-weight: bold;
  color: #11291B;
  border-radius: 20px;
}

.status-badge__enable {
  background-color: $green_light;
}

.status-badge__disable {
  background-color: $gray_2;
}

</style>